import { _ } from "../../../../core/polyglot/polyglot.js";
import AbstractTokenPeriodFilter from "./AbstractTokenPeriodFilter.js";

/**
 * Token period filter used for representing no filtering.
 */
export default class NullTokenPeriodFilter extends AbstractTokenPeriodFilter {
	isNull() {
		return true;
	}

	asFormulaNode({ expression }) {
		return expression;
	}

	static getLabel() {
		return _("None");
	}
}
